import { ThirdPartyCost } from '@app/core/model/third-party-cost.model'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { Department } from '@app/features/scoping/models/department.model'
import { Role } from '@app/features/scoping/models/role.model'
import { plainToInstance } from 'class-transformer'
import { Money } from '../model/money.model'
import { ScopeSection } from '../model/scope-section'
import { mapScopeFee } from './map-scope-fee.utils'

export function getMoneyValue(value: number | Money | undefined, currency: string): Money {
  return typeof value === 'number' ? new Money(value, currency) : value
}

export const mapScopeSection = (section: ScopeSection): ScopeSection =>
  plainToInstance(ScopeSection, {
    ...section,
    feeItems: section.feeItems
      ? section.feeItems.map((feeItem) => mapScopeFee(feeItem, { scopeSection: section }))
      : [],
  })

export function mapScopeTpc(tpc, currency: string): ThirdPartyCost {
  const costAmount = typeof tpc.cost === 'number' ? tpc.cost : tpc.cost?.amount
  const sellingPriceAmount = typeof tpc.sellingPrice === 'number' ? tpc.sellingPrice : tpc.sellingPrice?.amount

  const unitTypes = tpc.formula?.thirdPartyCostFormulaDefinitionSnapshot?.unitTypes
  const formula =
    unitTypes?.length === 1 && !tpc.formula?.unitType ? { ...tpc.formula, unitType: unitTypes[0] } : tpc.formula

  return plainToInstance(ThirdPartyCost, {
    ...tpc,
    formula,
    markupPercentageDecimal: tpc.markupPercentage * 100,
    cost: getMoneyValue(costAmount, currency),
    sellingPrice: getMoneyValue(sellingPriceAmount, currency),
    type: { id: 1, name: tpc.name },
  })
}

/** to API utils */

export function mapScopeComponentToApi(component: ScopeComponent) {
  return plainToInstance(ScopeComponent, {
    ...component,
    deliverable: null,
    departments: (component.departments || []).map((department) => mapScopeDepartmentToApi(department)),
  })
}

export function mapScopeDepartmentToApi(department: Department) {
  return plainToInstance(Department, {
    comments: department.comments,
    component: department.component,
    currencyUnit: department.currencyUnit,
    id: department.id,
    name: department.name,
    roles: department.roles.map((role) => mapScopeRoleToApi(role)),
    source: department.source,
    sourceType: department.sourceType,
  })
}

export function mapScopeRoleToApi(role: Role) {
  return plainToInstance(Role, {
    id: role.id,
    name: role.name,
    rateCardRate: role.rateCardRate,
    rateCardRole: role.rateCardRole,
    rateCardCost: role.rateCardCost,
    rateCardMinutes: role.rateCardMinutes,
    sourceType: role.sourceType,
  })
}

export function prepareScopeRoleForApi(role: any, currency: string): any {
  return {
    ...role,
    rate: getMoneyValue(role.rate, currency),
    cost: getMoneyValue(role.cost, currency),
  }
}

export function prepareScopeRolesForApi(scopeRoles: any[], currency: string): any[] {
  if (!scopeRoles) return scopeRoles
  return scopeRoles.map((role) => prepareScopeRoleForApi(role, currency))
}
